import React from 'react';
import { makeStyles, Container, Typography, Dialog, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import customAxios from "../../../API/customAxios"
import { useIntl } from 'react-intl';
import { DialogTitle, globalDialogStyle, messageBoxDialogStyle, DialogContent } from "../../../UIComponent/CommonStyle"
import { formatDateTimeHours } from '../../../Function/globalFunction';

const useStyles = makeStyles((theme) => ({
    ...globalDialogStyle(theme),
    ...messageBoxDialogStyle(theme),
    dialogPaper: {
        minWidth: 'auto',
        maxWidth: 'auto',
    },
    dialogContent: {
        ...globalDialogStyle(theme).dialogContent,
        width: 'auto',
        height: 'auto',
    },
    table: {
        minWidth: 'auto',
        maxWidth: 'auto',
    },
}));

export default function CancelAlertBox({
    open, 
    handleClose,
    compLeaveRecord
}) {
    const classes = useStyles();
    const intl = useIntl();
    const [newWindow, setNewWindow] = React.useState(null);

    const handleOpenEdit = (id) => {
        const newWindowUrl = `${window.location.origin}/employee_record_mgt/leave_record/${id}`;
        const newWindowReference = window.open(newWindowUrl, '_blank', 'noopener,noreferrer');
        setNewWindow(newWindowReference);
    };

    const handleCloseEdit = () => {
        if (newWindow) {
            newWindow.close();
            setNewWindow(null);
        }
    };

    return (
        <Container className={classes.container} variant="outlined">
            <Dialog 
                onClose={handleClose} 
                aria-labelledby="customized-dialog-title" 
                open={open}
                classes={{ paper: classes.dialogPaper }}
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    {intl.formatMessage({ id: 'cancel_alert.warning' })}
                </DialogTitle>
                <DialogContent dividers className={classes.dialogContent}>
                    <Typography variant="body1" style={{marginBottom: '20px'}} gutterBottom>
                        {intl.formatMessage({ id: 'cancel_alert.remainder' })}
                    </Typography>
                    <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell><strong>{intl.formatMessage({ id: 'common.id' })}</strong></TableCell>
                                    <TableCell><strong>{intl.formatMessage({ id: 'common.from' })}</strong></TableCell>
                                    <TableCell><strong>{intl.formatMessage({ id: 'common.to' })}</strong></TableCell>
                                    <TableCell><strong>{intl.formatMessage({ id: 'comp_leave.hours' })}</strong></TableCell>
                                    <TableCell><strong>{''}</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {compLeaveRecord.map((record, idx) => (
                                    <TableRow key={record.id || idx}>
                                        <TableCell>{record.comp_leave_application_id}</TableCell>
                                        <TableCell>{formatDateTimeHours(record, 'startDate', intl)}</TableCell>
                                        <TableCell>{formatDateTimeHours(record, 'untilDate', intl)}</TableCell>
                                        <TableCell>{record.hours.toFixed(1)}</TableCell>
                                        <TableCell 
                                            onClick={() => {
                                                handleOpenEdit(record.comp_leave_application_id)
                                            }}
                                        >   
                                            <Button 
                                                size="small"
                                                sx={{fontWeight: 'bold' }}
                                                variant="contained"
                                                color="secondary"
                                            >
                                                {intl.formatMessage({ id: 'cancel_alert.click_to_cancel' })}
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <div className={classes.yesButton} style={{ margin: '15px 0 10px 0' }}>
                        <Button
                            variant="contained"
                            size="small"
                            startIcon={<CheckCircleIcon />}
                            onClick={handleClose}
                            style={{ backgroundColor: 'green', color: '#FFF' }}
                        >
                            {intl.formatMessage({ id: 'cancel_alert.confirm_completed' })}
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        </Container>
    )
}
